export default {
  fund_code: 'Mã loại quỹ',
  fund_name: 'Tên loại quỹ',
  inactive: 'Ngừng theo dõi',

  // QuickSearch: {
  //   Title: 'Tìm nhân viên',
  // },
  List: {
    // Title: 'Cán bộ',
    AddBtn: 'Thêm',
    SearchEmptyText: 'Tìm kiếm',
    ActionColumn: 'Chức năng',
  },
  // detail: {
  //   asset_code: 'Mã tài sản',
  // },
};
